import isNil from "lodash/isNil";
import { setUser } from "./mutations";
import actions from "./actions";

const state = {
    user: undefined
};

const mutations = {
    [setUser]: (state, value) => (state.user = value)
};

const getters = {
    isUserLoggedIn: state => !isNil(state.user)
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
